import React, {useContext} from 'react';
import ReactJson, {ReactJsonViewProps} from "react-json-view";
import {NpiInternalContext} from "../../contexts/internal-context";

const NpiDisplayDebugJson = ({...props}:ReactJsonViewProps) => {
    const {isSuperAdmin} = useContext(NpiInternalContext);
    // @ts-ignore
    return isSuperAdmin ? <ReactJson collapsed={true} {...props}/>:<></>
};

export default NpiDisplayDebugJson;